import React, { useEffect, useRef, useState, memo } from 'react';
import { useTime } from '../../hooks/useTime';
import { formatDate, formatTime } from '../../utils/formatTime';
import styles from './Clock.module.css';

// 가상의 터미널 명령어들
const TERMINAL_COMMANDS = [
    'calculating temporal matrix',
    'syncing quantum chronometer',
    'accessing atomic clock network',
    'decoding timestamp encryption',
    'calibrating spacetime coordinates',
    'parsing UTC timestamp',
    'processing leap second',
    'synchronizing with GPS satellites',
    'running temporal verification',
    'calculating epoch milliseconds'
];

const pick = <T,>(items: T[]) => items[Math.floor(Math.random() * items.length)];

/**
 * 디지털 시계: 현재 시각과 터미널 명령어 애니메이션
 */
const DigitalClockComponent: React.FC = () => {
    const { date } = useTime();
    const [line, setLine] = useState('');
    const timerRef = useRef<number | undefined>(undefined);

    // 한 줄을 타이핑하고 잠시 뒤 다음 줄로 넘어간다
    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            setLine(pick(TERMINAL_COMMANDS));
            return;
        }

        const typeLine = () => {
            const command = pick(TERMINAL_COMMANDS);
            let length = 0;

            const typeNextChar = () => {
                length += 1;
                setLine(command.slice(0, length));
                timerRef.current = window.setTimeout(
                    length < command.length ? typeNextChar : typeLine,
                    length < command.length ? 45 + Math.random() * 70 : 3500 + Math.random() * 3000,
                );
            };

            typeNextChar();
        };

        typeLine();
        return () => window.clearTimeout(timerRef.current);
    }, []);

    const { ampm, time } = formatTime(date);

    return (
        <div className={styles.clockContainer}>
            <p className={styles.timeContainer}>
                <span className={styles.ampmDisplay}>{ampm}</span>
                <span className={styles.timeDisplay}>{time}</span>
            </p>
            <div className={styles.side}>
                <p className={styles.dateDisplay}>{formatDate(date)}</p>
                <p className={styles.terminalLine} aria-hidden="true">&gt; {line}<span className={styles.cursor}>_</span></p>
            </div>
        </div>
    );
};

// React.memo로 불필요한 리렌더링 방지
export const DigitalClock = memo(DigitalClockComponent);

export default DigitalClock;
